module.exports = __webpack_public_path__ + "static/img/lose.d65f6f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/win_lose/lose.png
// module id = KeEi
// module chunks = 1